import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-pager',
  templateUrl: './custom-pager.component.html',
  styleUrls: ['./custom-pager.component.css']
})
export class CustomPagerComponent {
  @Input() pagesCount = 0
  @Input() page = 0
  @Output() pageChange: EventEmitter<number> = new EventEmitter()

  // Calculates what page options should be shown to the user, will always show 5 numbers 
  calculateRange(){
    if(this.pagesCount === 0){
      return []
    }
    const step = 2
    const doubleStep: number = step * 2
    const start: number = Math.max(0, this.page - step)
    let end: number = start + 1 + doubleStep
    if(end > this.pagesCount) { 
      end = this.pagesCount
    }

    const result = []
    for(let i = start; i != end; i++){
      result.push(i)
    }

    return result
  }
  
  // helper function to calculate page number to change to
  pagePlus(count: number){
    return this.page + count
  }
}
